export default __webpack_public_path__ + "e8739fd7cd8cc6d6dbfad706bd9d0ea0.ttf";